export const colors3 = [
    'primary', 'danger', 'info', 'primary',
    'primary', 'warning', 'warning', 'primary',
    'info', 'danger', 'warning', 'info',
    'info', 'primary', 'warning', 'primary',
    'primary', 'warning', 'warning', 'primary',
    'info', 'primary', 'warning', 'primary',
    'info', 'warning', 'warning', 'warning',
    'primary', 'danger', 'warning', 'primary',
    'info', 'warning', 'warning', 'primary',
    'primary', 'danger', 'warning', 'primary',
    'info', 'warning', 'warning', 'primary',
    'info', 'warning', 'warning', 'primary',
    'primary', 'primary', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'warning', 'warning', 'primary',
    'primary', 'danger', 'warning', 'primary',
    'info', 'primary', 'warning', 'primary',
    'primary', 'danger', 'warning', 'primary',
    'info', 'warning', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'warning', 'warning', 'primary',
    'info', 'primary', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'primary', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'primary', 'warning', 'primary',
    'info', 'warning', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'warning', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'warning', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'warning', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'warning', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'warning', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',
    'info', 'danger', 'warning', 'primary',

];


export const colors13 = [
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',
    'info', 'warning', 'primary',

];
export const colors33 = [
    'danger', 'default', 'info', 'primary', 'warning',
    'danger', 'default', 'info', 'primary', 'warning',
    'danger', 'default', 'info', 'primary', 'warning',
    'danger', 'default', 'info', 'primary', 'warning',
    'danger', 'default', 'info', 'primary', 'warning',
    'danger', 'default', 'info', 'primary', 'warning',
    'danger', 'default', 'info', 'primary', 'warning',
    'danger', 'default', 'info', 'primary', 'warning',
    'danger', 'default', 'info', 'primary', 'warning',
    'danger', 'default', 'info', 'primary', 'warning',
    'danger', 'default', 'info', 'primary', 'warning',
    'danger', 'default', 'info', 'primary', 'warning',
    'danger', 'default', 'info', 'primary', 'warning',
    'danger', 'default', 'info', 'primary', 'warning'
];

export const colors43 = [
    'primary', 'warning', 'default', 'info', 'danger',
    'primary', 'warning', 'default', 'info', 'danger',
    'primary', 'warning', 'default', 'info', 'danger',
    'primary', 'warning', 'default', 'info', 'danger',
    'primary', 'warning', 'default', 'info', 'danger',
    'primary', 'warning', 'default', 'info', 'danger',
    'primary', 'warning', 'default', 'info', 'danger',
    'primary', 'warning', 'default', 'info', 'danger',
    'primary', 'warning', 'default', 'info', 'danger',
    'primary', 'warning', 'default', 'info', 'danger',
    'primary', 'warning', 'default', 'info', 'danger',
    'primary', 'warning', 'default', 'info', 'danger',
    'primary', 'warning', 'default', 'info', 'danger',
    'primary', 'warning', 'default', 'info', 'danger',
    'primary', 'warning', 'default', 'info', 'danger',

];


export const colors44 = [
    'primary', 'info', 'danger', 'default', 'warning',
    'primary', 'info', 'danger', 'default', 'warning',
    'primary', 'info', 'danger', 'default', 'warning',
    'primary', 'info', 'danger', 'default', 'warning',
    'primary', 'info', 'danger', 'default', 'warning',
    'primary', 'info', 'danger', 'default', 'warning',
   'primary', 'info', 'danger', 'default', 'warning',
    'primary', 'info', 'danger', 'default', 'warning',
    'primary', 'info', 'danger', 'default', 'warning',
    'primary', 'info', 'danger', 'default', 'warning',
    'primary', 'info', 'danger', 'default', 'warning',
    'primary', 'info', 'danger', 'default', 'warning',
    'primary', 'info', 'danger', 'default', 'warning',
    'primary', 'info', 'danger', 'default', 'warning',
    'primary', 'info', 'danger', 'default', 'warning',
    'primary', 'info', 'danger', 'default', 'warning',
    'primary', 'info', 'danger', 'default', 'warning',
    'primary', 'info', 'danger', 'default', 'warning',
];


export const colors45 = [
    'info', 'warning', 'danger', 'primary', 'default',
    'info', 'warning', 'danger', 'primary', 'default',
    'info', 'warning', 'danger', 'primary', 'default',
    'info', 'warning', 'danger', 'primary', 'default',
    'info', 'warning', 'danger', 'primary', 'default',
    'info', 'warning', 'danger', 'primary', 'default',
    'info', 'warning', 'danger', 'primary', 'default',
    'info', 'warning', 'danger', 'primary', 'default',
    'info', 'warning', 'danger', 'primary', 'default',
    'info', 'warning', 'danger', 'primary', 'default',
    'info', 'warning', 'danger', 'primary', 'default',
    'info', 'warning', 'danger', 'primary', 'default',
    'info', 'warning', 'danger', 'primary', 'default',
    'info', 'warning', 'danger', 'primary', 'default',
    'info', 'warning', 'danger', 'primary', 'default',
    'info', 'warning', 'danger', 'primary', 'default',
];



export const colors = [
    'info', 'danger', 'default', 'primary', 'warning',
    'info', 'danger', 'default', 'primary', 'warning',
    'info', 'danger', 'default', 'primary', 'warning',
    'info', 'danger', 'default', 'primary', 'warning',
    'info', 'danger', 'default', 'primary', 'warning',
    'info', 'danger', 'default', 'primary', 'warning',
    'info', 'danger', 'default', 'primary', 'warning',
    'info', 'danger', 'default', 'primary', 'warning',
    'info', 'danger', 'default', 'primary', 'warning',
    'info', 'danger', 'default', 'primary', 'warning',
    'info', 'danger', 'default', 'primary', 'warning',
    'info', 'danger', 'default', 'primary', 'warning',
    'info', 'danger', 'default', 'primary', 'warning',
    'info', 'danger', 'default', 'primary', 'warning',
    'info', 'danger', 'default', 'primary', 'warning',
    'info', 'danger', 'default', 'primary', 'warning',
    'info', 'danger', 'default', 'primary', 'warning',
    'info', 'danger', 'default', 'primary', 'warning',
    'info', 'danger', 'default', 'primary', 'warning',
    'info', 'danger', 'default', 'primary', 'warning',
    'info', 'danger', 'default', 'primary', 'warning',
    'info', 'danger', 'default', 'primary', 'warning',
    'info', 'danger', 'default', 'primary', 'warning',
    'info', 'danger', 'default', 'primary', 'warning',
    'info', 'danger', 'default', 'primary', 'warning',
    'info', 'danger', 'default', 'primary', 'warning',
    'info', 'danger', 'default', 'primary', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',
    'info', 'danger', 'default', 'warning',

];